<section>
  <!-- start popup header -->
  <div class="header">
    <h3>{{data.title}}</h3>
    <button (click)="onClose(dialogRef)"><app-svg-icon [icon]="IconConstants.CLOSE_ICON"></app-svg-icon></button>
  </div>
  <!-- end popup header -->

  <!-- ---------------------- -->
  <!-- start popup content -->
  <div class="content">
    <div class="loading" *ngIf="loadingService.loadingPopup$ | async">
      <app-spinner></app-spinner>
    </div>
    <!-- template to pass popup content -->
    <ng-template
      [ngTemplateOutlet]="template"
      [ngTemplateOutletContext]="{$implicit : initializeCaller , dialogRef : dialogRef , data : data.data}"
    ></ng-template>
  </div>
  <!-- end popup content -->
</section>
